import React from 'react';
import { IntlProvider } from 'react-intl';
import { translations } from '../lang/translations';
import { defaultLocale } from '../lang/default';
import { resolveLocale } from './localeRegistry';

const TranslationProvider = (WrappedComponent: any) => (props: any) => {
  const locale = resolveLocale(props.locale || defaultLocale);
  const messages = {
    ...translations.fr,
    ...translations[locale || defaultLocale],
  };
  return (
    <IntlProvider locale={locale} key={locale} messages={messages}>
      <WrappedComponent {...props} locale={locale} />
    </IntlProvider>
  )
};

export default TranslationProvider;
